// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopArticleTaxByIdRequestModel from '../../model/delete-shop-article-tax-by-id-request-model';
import DeleteShopArticleTaxByIdRequestDTO from '../dto/delete-shop-article-tax-by-id-request-dto';
import dtoSchema from '../schemas/delete-shop-article-tax-by-id-request-schema';

export default abstract class DeleteShopArticleTaxByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopArticleTaxByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopArticleTaxByIdRequestDTO>): DeleteShopArticleTaxByIdRequestModel;
  static toModel(dto: DeepPartial<DeleteShopArticleTaxByIdRequestDTO> | undefined | null): DeleteShopArticleTaxByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopArticleTaxByIdRequestDTO> | undefined | null): DeleteShopArticleTaxByIdRequestModel | undefined {
    return dto ? new DeleteShopArticleTaxByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopArticleTaxByIdRequestModel> | DeleteShopArticleTaxByIdRequestModel): DeleteShopArticleTaxByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopArticleTaxByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopArticleTaxByIdRequestModel, can not map to DeleteShopArticleTaxByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
